<template>
  <div :class="cn('tw:relative tw:bg-white tw:rounded-md tw:w-full tw:h-[calc(2.45rem+2px)] tw:max-w-sm tw:items-center', $attrs.class)">
    <Input
      v-model="searchValue"
      type="text"
      :placeholder="placeholder"
      :name="name"
      :class="cn('tw:pr-10 tw:h-full tw:min-h-9', {
        'tw:pl-10': withClearButton,
      })"
      @keyup.enter="onSearch"
      @keydown.stop=""
    />

    <button
      v-if="withClearButton"
      v-show="shouldShowClear"
      type="button"
      data-slot="clear-button"
      class="tw:absolute tw:right-0 tw:inset-y-0 tw:flex tw:items-center tw:justify-center tw:px-3 tw:text-muted-foreground hover:tw:text-foreground"
      @click="searchValue = ''"
    >
      <i class="tw:i-fas-circle-xmark tw:size-4" />
    </button>

    <button
      type="button"
      data-slot="search-button"
      :class="cn('tw:absolute tw:inset-y-0 tw:flex tw:items-center tw:justify-center tw:px-3', {
        'tw:left-0': withClearButton,
        'tw:right-0': !withClearButton,
      })"
      @click="onSearch"
    >
      <i class="tw:i-fal-magnifying-glass tw:size-4" />
    </button>
  </div>
</template>

<script setup>
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import { Input } from '@/shadcn/components/ui/input/index.js'
import { cn } from '@/shadcn/lib/utils.js'

defineOptions({
  name: 'SearchInput',
  inheritAttrs: false,
})

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Search...',
  },
  name: {
    type: String,
  },
  withClearButton: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'search'])

const searchValue = useVModel(props)

const shouldShowClear = computed(() => searchValue.value.length > 0)

function onSearch() {
  emit('search', searchValue.value)
}
</script>
